var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.textObject)?_c('div',{staticClass:"whole-sentence"},[_c('div',{staticClass:"user-info"},[_c('el-avatar',{attrs:{"src":_vm.textObject.imageSrc}})],1),_c('div',{staticClass:"user-sentence",domProps:{"innerHTML":_vm._s(_vm.textObject.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }